<div class="flex flex-col items-center justify-center h-screen my-20 md:my-10">
    <p-toast></p-toast>
    
    <div class="flex flex-col items-center justify-start border border-gray-200 rounded-lg p-10 mx-5 md:mx-0 lg:min-w-[450px]">
        <img src="assets/logo.png" alt="Office Global Logo" class=" h-[60px] object-contain">
        <h1 class="text-2xl font-bold mt-2" i18n>Welcome</h1>
        <p class="text-base text-gray-500 mt-2" i18n>Enter your information to create your account.</p>

        <form class="w-full flex flex-col items-center" [formGroup]="signUpForm" (ngSubmit)="onSubmit()">
            <div class="w-full flex flex-col gap-2 mt-5">
                <div class="w-full flex items-center justify-start">
                    <label class="text-start text-sm" for="username" i18n>Company Name <span class="text-red-500">*</span></label>
                </div>
                <input pInputText formControlName="companyName" i18n-placeholder placeholder="Enter Company Name" type="text" autocomplete="companyName" class="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
                <small class="text-red-500" *ngIf="signUpForm.get('companyName')?.invalid && signUpForm.get('companyName')?.touched" i18n>
                    Please enter company name
                </small>
            </div>
            <div class="w-full flex flex-col gap-2 mt-5">
                <div class="w-full flex items-center justify-start">
                    <label class="text-start text-sm" for="username" i18n>Email <span class="text-red-500">*</span></label>
                </div>
                <input pInputText formControlName="email" i18n-placeholder placeholder="e.g jacob.jhon@purple" type="email" autocomplete="email" class="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
                <small class="text-red-500" *ngIf="signUpForm.get('email')?.invalid && signUpForm.get('email')?.touched">
                    <span *ngIf="signUpForm.get('email')?.errors?.['required']" i18n>Please enter email address</span>
                    <span *ngIf="signUpForm.get('email')?.errors?.['email']" i18n>Please enter a valid email address</span>
                </small>
            </div>
            <div class="w-full flex flex-col gap-2 mt-5">
                <div class="w-full flex items-center justify-start">
                    <label class="text-start text-sm" for="username" i18n>First Name <span class="text-red-500">*</span></label>
                </div>
                <input pInputText formControlName="firstName" i18n-placeholder placeholder="Enter First Name" type="text" autocomplete="firstName" class="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
                    <small class="text-red-500" *ngIf="signUpForm.get('firstName')?.invalid && signUpForm.get('firstName')?.touched" i18n>
                    Please enter first name
                </small>
            </div>
            <div class="w-full flex flex-col gap-2 my-5">
                <div class="w-full flex items-center justify-start">
                    <label class="text-start text-sm" for="username" i18n>Last Name <span class="text-red-500">*</span></label>
                </div>
                <input pInputText formControlName="lastName" i18n-placeholder placeholder="Enter Last Name" type="text" autocomplete="lastName" class="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
                <small class="text-red-500" *ngIf="signUpForm.get('lastName')?.invalid && signUpForm.get('lastName')?.touched" i18n>
                    Please enter last name
                </small>
            </div>

            <p-button 
                type="submit" 
                class="w-full text-base cursor-pointer text-white rounded-lg disabled:bg-gray-400 disabled:cursor-not-allowed"
                [disabled]="signUpForm.invalid || loading">
                <span *ngIf="!loading" i18n>Continue</span>
                <span *ngIf="loading" i18n>Loading...</span>
            </p-button>

        </form>
    </div>
</div>